// extracted by mini-css-extract-plugin
module.exports = {"output":"output_output__vfN5U"};